import BeatLoader from "react-spinners/BeatLoader";

const Spinner = () => {
  return (
    <BeatLoader
      color={"#2762da"}
      loading={true}
      size={20}
      cssOverride={{
        display:'flex',
        justifyContent:'center'
      }}
      aria-label="Loading Spinner"
      data-testid="loader"
    />
  );
};

export default Spinner;
